/* @flow */
import * as React from 'react';

import './styles/Toast.scss';

/**
 * ## Used to surface a [Notice](/internal/components/Notice) globally.
 *
 * # Implementation
 *
 * Prefer [SuccessToast](/internal/components/SuccessToast) or
 * [ErrorToast](/internal/components/ErrorToast)
 *
 *
 * ```example
 * <Toast>
 *   Toast
 * </Toast>
 * ```
 */

class Toast extends React.Component<$FlowFixMeProps> {
  render() {
    return (
      <div className="Toast">
        <div className="Toast-contents">{this.props.children}</div>
      </div>
    );
  }
}

export default Toast;
